import { Input, Pagination, Table } from 'antd';
import React, { FC } from 'react';
import { TPreparedAcceptSettings, TPreparedAcceptSettingsColumns } from 'shared/types/vacation-schedule.types';
import { SearchKeysAcceptSettings } from 'shared/enums/vacations-schedule';
import OrganizationInput from 'features/controls/addAdmin/organizationInput/OrganizationInput';
import style from './index.module.scss';

type TProps = {
  dataSource: TPreparedAcceptSettings[];
  columns: TPreparedAcceptSettingsColumns;
  currentPage: number;
  currentSize: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  setCurrentSize: React.Dispatch<React.SetStateAction<number>>;
  total: number | undefined;
  onclickToRow?: (id: string) => void;
};

const AcceptSettingsTable: FC<TProps> = ({
  columns,
  currentPage,
  currentSize,
  dataSource,
  setCurrentPage,
  setCurrentSize,
  total,
  onclickToRow,
}) => {
  const handlePagination = (value: number, pageSize: number) => {
    setCurrentSize(pageSize);
    setCurrentPage(value);
  };

  return (
    <>
      <>
        <Table
          scroll={{ x: true }}
          dataSource={dataSource}
          columns={columns}
          rowClassName="row"
          pagination={false}
          bordered
          onRow={(record, rowIndex) => {
            return {
              onClick: () => {
                if (onclickToRow) {
                  onclickToRow(record.key);
                }
              },
            };
          }}
        />
        <div className={style.paginationWrap}>
          <Pagination
            defaultCurrent={1}
            showSizeChanger
            current={currentPage}
            total={total}
            pageSize={currentSize}
            onChange={(page, pageSize) => handlePagination(page, pageSize)}
          />
        </div>
      </>
    </>
  );
};

export default AcceptSettingsTable;
